import { useLocale } from '@app/core/hooks/useLocale';
import { SecondaryNavigation } from '@app/shared/components/secondary-navigation/SecondaryNavigation';
import { NavigationItem } from '@app/shared/components/secondary-navigation/secondary-navigation-types';
import { RouteConstants } from '../../RouteConstants';
import { SecondaryNavigationVariation } from '@app/shared/components/secondary-navigation/secondary-navigation-enums';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { selectIsCompatibilityMode } from '@app/core/store/project-slice-selectors';

// These routes are used for navigating between the sub-pages of the Capital Structure page.
export const CapitalStructureRoutes = {
  BuildStructure: `../${RouteConstants.BuildStructure}`,
  PayoutLogic: `../${RouteConstants.PayoutLogic}`,
  CapTable: `../${RouteConstants.CapTable}`,
  Dividends: `../${RouteConstants.Dividends}`,
  ParticipationTable: `../${RouteConstants.ParticipationTable}`,
  SourcesAndUses: `../${RouteConstants.SourcesAndUses}`,
  EquityBridge: `../${RouteConstants.EquityBridge}`,
};

export const CapitalStructureNavigation = () => {
  const { l } = useLocale();
  const isCompatibilityMode = useAppSelector(selectIsCompatibilityMode);

  const navigationItems: NavigationItem[] = [
    {
      label: l('_BuildStructure'),
      route: CapitalStructureRoutes.BuildStructure,
    },
    {
      label: l('_PayoutLogic'),
      route: CapitalStructureRoutes.PayoutLogic,
    },
    {
      label: l('_CapTable'),
      route: CapitalStructureRoutes.CapTable,
    },
    {
      label: l('_ParticipationTable'),
      route: CapitalStructureRoutes.ParticipationTable,
    },
    {
      label: l('_SourcesAndUses'),
      route: CapitalStructureRoutes.SourcesAndUses,
    },
    {
      label: l('_EquityBridge'),
      route: CapitalStructureRoutes.EquityBridge,
    },
    ...(!isCompatibilityMode
      ? [
          {
            label: l('_Dividends'),
            route: CapitalStructureRoutes.Dividends,
          },
        ]
      : []),
  ];

  return (
    <SecondaryNavigation
      navigationItems={navigationItems}
      variation={SecondaryNavigationVariation.Scrollable}
    />
  );
};
